export enum ApprovalsTab {
  Payments = 'payments',
  Controls = 'controls',
}
